import { Badge, type BadgeProps } from '@amzn/awsui-components-console';
import type { Severity } from '@amzn/helianthus-arbiter-client';

const SEVERITY_DISPLAY: Record<Severity, { color: BadgeProps['color']; label: string }> = {
  CRITICAL: { color: 'severity-critical', label: 'Critical' },
  HIGH: { color: 'severity-high', label: 'High' },
  MEDIUM: { color: 'severity-medium', label: 'Medium' },
  LOW: { color: 'severity-low', label: 'Low' },
};

/** Sentence-case label for a severity, as Cloudscape writing guidelines ask. */
export function severityLabel(severity: Severity): string {
  return SEVERITY_DISPLAY[severity]?.label ?? severity;
}

/** The one way severity is shown, so every page uses the same Cloudscape severity palette. */
export function SeverityBadge({ severity }: { severity: Severity }) {
  const display = SEVERITY_DISPLAY[severity];
  return <Badge color={display?.color ?? 'severity-neutral'}>{display?.label ?? severity}</Badge>;
}
